export default __webpack_public_path__ + "static/media/infra-5.f9e3ec59.webp";